import { useQuery } from '@tanstack/react-query';
import { api_host, api_auth } from '../common/globals/constants';
import { getApiKeys } from '../utils/fns/get-api-keys';

const fetchBenchmarkFilters = async (user_id, token) => {
  const url = `${api_host}/reporte/online/indicadores/getBenchmarkFilters/?user=${user_id}&key=${api_auth}&token=${token}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
};

export const useBenchmarkFilters = (options = {}) => {
  const {user, token} = getApiKeys();

  return useQuery({
    queryKey: ['benchmarkFilters', user],
    queryFn: () => fetchBenchmarkFilters(user, token),
    enabled: !!user && !!token,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 30,
    refetchInterval: 600000,
    ...options
  });
};
